import equal from 'fast-deep-equal/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setDivision } from '~/Actions/ActionApp';
import Select from '~/Components/Select/Select';
import { State } from '~/Reducers';
import { getAvailableDivisions } from '~/utils/statistics';

import { getDivisionsFromBattletype } from './config';
import styles from './DivisionPicker.scss';

export interface DivisionPickerProps {
  noNavigation?: boolean;
  allTypes?: boolean;
  availableStatsBattleTypes: Array<StatBattleType>;
}

export interface DivisionPickerState {
  battleTypeRaw: BattleTypeName;
}

const stateSelector = (state: State): DivisionPickerState => {
  return {
    battleTypeRaw: state.ReducerApp.battleTypeRaw,
  };
};

const DivisionPicker = (props: DivisionPickerProps) => {
  const state = useSelector<State, DivisionPickerState>(stateSelector, equal);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { battleTypeRaw } = state;
  const allDivisions: DivisionName[] = ['', 'solo', 'div', 'div2', 'div3'];
  const availableDivisions: DivisionName[] = getAvailableDivisions(
    battleTypeRaw,
    allDivisions,
    props.availableStatsBattleTypes,
  );

  const Divisions = getDivisionsFromBattletype(battleTypeRaw as BattleTypeNameWithDivisions, t).filter((division) =>
    availableDivisions.includes(division.value),
  );

  const renderValue = () => {
    const title = Divisions[selectedIndex] ? Divisions[selectedIndex].title : ' ';
    return <div className={styles.value}>{title}</div>;
  };

  const renderItem = (index: number) => {
    return Divisions[index].title;
  };

  const onSelectHandler = (index: number) => {
    setSelectedIndex(index);
    const value = Divisions[index] ? Divisions[index].value : undefined;
    dispatch(setDivision(value as DivisionName));
  };

  useEffect(() => {
    onSelectHandler(0);
  }, [battleTypeRaw]);

  if (Divisions === undefined || Divisions.length === 0) {
    return null;
  }

  return (
    <Select
      maxItemsCount={Divisions.length}
      items={Divisions.map((item) => item.value)}
      selectedIndex={selectedIndex}
      onSelect={onSelectHandler}
      renderValue={renderValue}
      renderItem={renderItem}
    />
  );
};

export default DivisionPicker;
